var _g, _path, _path2, _path3, _g2, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompliancePptxFileExpired = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 47,
  height: 51,
  viewBox: "0 0 47 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#wvrqctwc0a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.313 1.067h29.989l11.466 11.991v33.638c0 .72-.558 1.304-1.247 1.304H3.313c-.688 0-1.246-.584-1.246-1.304V2.37c0-.72.558-1.303 1.246-1.303z",
  fill: "#F0EFEF"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.794 1.58 45.26 13.574H35.04c-.688 0-1.246-.584-1.246-1.304V1.581z",
  fill: "#ABABAB"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.857 17.013h-13.38A2.676 2.676 0 0 0 13.8 19.69v13.208a2.676 2.676 0 0 0 2.676 2.676h13.38a2.676 2.676 0 0 0 2.677-2.676V19.69a2.676 2.676 0 0 0-2.676-2.676z",
  fill: "#ABABAB"
})), /*#__PURE__*/React.createElement("mask", {
  id: "naavkl895b",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 23,
  y: 20,
  width: 6,
  height: 6
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8 20.8h4.366v4.44H23.8V20.8z",
  fill: "#fff"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#naavkl895b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.705 25.24h4.367c-.196-2.372-2.048-4.257-4.367-4.44v4.44z",
  fill: "#fff"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.48 26.012a4.53 4.53 0 1 1-4.53-4.53v4.53h4.53z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "wvrqctwc0a",
  x: 0.067,
  y: 0.067,
  width: 46.701,
  height: 50.933,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_389_461"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_389_461",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompliancePptxFileExpired);
export default ForwardRef;